// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"141":"async-null","675":"async-DashKetcher"}[chunkId] + ".js";
};